export default __webpack_public_path__ + "static/media/doctor1.b10b6c92.jpg";